<template>
  <a
    target="_blank"
    :href="link"
    class="doc-link d-flex py-16 px-8 hover-color-hover-primary"
  >
    <Icon iconName="icon-document" className="icon-24 mr-8" />
    <span class="doc-link__name d-block nowrap">
      {{ text }}
    </span>
    <span class="doc-link__line d-block grid-col_full px-8"></span>
    <span class="d-block text-uppercase fw-medium">
      {{ docType }}
    </span>
  </a>
</template>

<script>
import Icon from "../Icon/Icon.vue";
export default {
  name: "DocLink",
  components: {
    Icon,
  },
  props: {
    text: {
      type: String,
      default: "",
    },
    link: {
      type: String,
      default: "",
    },
    docType: {
      type: String,
      default: ".pdf",
    },
  },
};
</script>

<style lang="scss">
@import "./doc-link.scss";
</style>
